import { useState, forwardRef } from 'react';
import type {
  TextFieldProps} from '@mui/material';
import {
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

type PasswordInputProps = TextFieldProps & {
  enableToggle?: boolean;
};

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ enableToggle = true, type, ...props }, ref) => {
    const [show, setShow] = useState(false);
    const inputType = enableToggle ? (show ? 'text' : 'password') : type ?? 'password';

    return (
      <TextField
        {...props}
        type={inputType}
        inputRef={ref}
        InputProps={{
          ...props.InputProps,
          endAdornment: enableToggle ? (
            <InputAdornment position="end">
              <IconButton
                tabIndex={-1}
                edge="end"
                aria-label={show ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                onClick={() => setShow((prev) => !prev)}
              >
                {show ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ) : (
            props.InputProps?.endAdornment
          ),
        }}
      />
    );
  }
);

PasswordInput.displayName = 'PasswordInput';